export const getOffset = (frameType, area) => {
  const defaultOffset = 15;

  // Ensure validity of area.AreaCn
  if (!area || typeof area.AreaCn !== "string" || area.AreaCn.trim() === "") {
    console.error(
      `Invalid or empty area.AreaCn ${area.AreaCn} on frameType ${frameType}`
    );
    return defaultOffset;
  }

  if (area.AreaCn.includes("BACK") || area.AreaCn.includes("FRONT")) {
    return frameType === "ONSKA" || frameType === "SKAPA" ? 10 : 20;
  }

  return defaultOffset;
};

export const getOffsets = (frameAreas, corner, frameType) => {
  const offsets = [];

  if (frameAreas) {
    frameAreas.forEach(area => {
      const offset = getOffset(frameType, area);
      const value = parseInt(area.Value, 10) + offset;
      const valueBroken = parseInt(area.ValueBroken, 10) + offset;

      if (area.AreaCn.includes("TOP") || area.AreaCn.includes("PITCHED")) {
        return;
      }

      switch (corner) {
        case "NONE":
          offsets.push({
            [area.AreaCn]: valueBroken,
          });
          break;

        case "TWO":
          offsets.push({
            [area.AreaCn]: valueBroken,
          });
          break;

        case "LEFT":
          if (
            area.AreaCn === "ONSIDE_LEFT" ||
            area.AreaCn === "FRONT_LEFT" ||
            area.AreaCn === "FRONT"
          ) {
            offsets.push({
              [area.AreaCn]: valueBroken,
            });
          } else {
            offsets.push({
              [area.AreaCn]: value,
            });
          }
          break;

        case "RIGHT":
          if (
            area.AreaCn === "ONSIDE_RIGHT" ||
            area.AreaCn === "FRONT_RIGHT" ||
            area.AreaCn === "FRONT"
          ) {
            offsets.push({
              [area.AreaCn]: valueBroken,
            });
          } else {
            offsets.push({
              [area.AreaCn]: value,
            });
            break;
          }
          break;
        default:
      }
    });
  }

  var offsetsObj = {};
  offsets.forEach(function (item) {
    var key = Object.keys(item)[0];
    offsetsObj[key] = item[key];
  });

  return offsetsObj;
};
